import { render } from "./TheFooter.vue?vue&type=template&id=97727db4"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=97727db4&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__